<template>
  <div>
    <b-container>
      <div class="row justify-content-center">
        <div class="column w-75">
          <div class="mt-4 d-flex align-items-start justify-content-between">
            <back-arrow :title="$t('my.lampions.title')"/>
          </div>

          <div class="d-flex flex-column justify-content-center mt-4 mb-4">
            <div class="d-flex justify-content-center w-100">
              <div class="page-title lampions-nb mr-2">{{ lampionsInfos.lampionsUser }}</div>
              <img class="coin-image mt-2" :src="require(`@/assets/images/b122/ic_coin.png`)">
            </div>
            <div class="currentLoopGrades mt-1">
                    <span v-for="loopGrade in lampionsInfos.currentLoopGrades"
                          :class="loopGrade.gradeName === lampionsInfos.currentGradeName ? 'currentLoopGrade' : ''">
                      {{ loopGrade.gradeName }}
                    </span>
            </div>
            <div class="currentLevel mt-1 mb-2">
              {{$t('level')}} {{ lampionsInfos.currentLevelNumber }}
            </div>
            <div class="w-100 d-flex flex-column align-items-center">
              <b-progress
                class="w-100 lampions-progress"
                :max="lampionsInfos.nbPointsInCurrentLevel"
                no-value
              >
                <b-progress-bar
                  class="lampions-progress-bar"
                  :value="(lampionsInfos.currentNbOfPoints)"
                />
              </b-progress>
              <div class="lampions-progress-value">
                {{ lampionsInfos.currentNbOfPoints }} / {{ lampionsInfos.nbPointsInCurrentLevel }}
              </div>
            </div>
            <div class="three-match-warning mt-1 mb-2">
              <span class="main-grey-light-color">{{$t('my.lampions.warning')}}</span> {{$t('my.lampions.3.tries')}}
            </div>
            <div class="my-progress-title mt-4">
              {{$t('my.lampions.my.progress')}}
            </div>
            <div class="loops mt-3 mb-2">
              <div v-for="(loop, index) in lampionsInfos.loops" :key="index" v-if="index >= currentLoopIndex" class="loop">
                <div class="flex-container">
                  <div class="vertical-line" :class="{ 'hidden-bar': index === currentLoopIndex }"></div>
                  <div class="circle" :class="{ 'lampions-progress-bar': index === currentLoopIndex }"></div>
                  <div class="vertical-line" :class="{ 'hidden-bar': index === lampionsInfos.loops.length-1 }"></div>
                </div>
                <span class="loopName">{{ loop.name }}</span> <span>{{$t('from.level')}} {{loop.levelMin}} {{$t('to')}} {{loop.levelMax}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-container>
  </div>
</template>

<script>
import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow.vue'

export default {

  name: 'MyLampions',
  components: {BackArrow},

  data() {
    return {
      userId: this.$store.getters.userId,
      user: {},

      lampionsInfos: {},
    }
  },

  mounted() {
    this.fetchData()
  },

  computed: {
    currentLoopIndex() {
      return this.lampionsInfos.loops.findIndex(loop => loop.name === this.lampionsInfos.currentLoop);
    }
  },

  methods: {

    async fetchData() {
      this.fetchLampions()
    },

    fetchLampions() {
      api
        .get(`/user/getUserInfoLampions`)
        .then(response => {
          this.lampionsInfos = response.data
        })

    }
  }
}
</script>

<style scoped>
.category-card {
  height: 120px;
  border-radius: var(--fifth-border-radius);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}

.category-card-title {
  font-family: "KumbhSans-Regular", "Arial", sans-serif;
  font-size: var(--menu-font-size);
  color: var(--main-grey-light);
}

.category-number {
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: 54px;
  color: var(--main-yellow-medium);
  line-height: 50px;
}

.category-icon {
  font-size: 100px;
  color: var(--main-black-light);
}

.coin-image {
  width: 24px;
  height: 24px;
}

.lampions-nb {
  font-size: 30px;
}

.currentLoopGrades {
  display: flex;
  justify-content: center;
  gap: 6px;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  color: var(--main-grey-light);
}

.currentLoopGrade {
  color: var(--main-yellow-medium);
}

.currentLevel {
  width: 100%;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  color: var(--main-grey-medium);
}

.lampions-progress {
  background-color: var(--main-grey-dark);
  height: 20px;
}

.lampions-progress-bar {
  background-color: var(--main-yellow-medium) !important;
}

.lampions-progress-value {
  position: relative;
  top: -24px;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--title-level-three-font-size);
  color: var(--main-black-darker);
}

.three-match-warning {
  width: 100%;
  color: var(--main-grey-medium);
}

.my-progress-title {
  width: 100%;
  color: var(--main-grey-light);
  font-weight: bold;
}

.loops {
  color: var(--main-grey-medium);
}

.loop {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loopName{
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--menu-font-size);
  color: var(--main-yellow-medium);
  margin-bottom: 6px;
}

.vertical-line {
  width: 5px;
}

.flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.vertical-line {
  width: 5px;
  height: 20px;
  background-color: var(--main-grey-medium);
}

.circle {
  width: 15px;
  height: 15px;
  background-color: var(--main-grey-medium);;
  border-radius: 50%;
}

.hidden-bar {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/user/MyLampions.vue